<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>

            <b-card>
                <template v-slot:header>
                    <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 pb-3" style="border-bottom: 1px solid #c8ced3;">
                        
                        <div class="d-flex flex-column">
                            <h5 style="border-bottom: none;" class="pb-0 mb-1">Kas Cabang</h5>
                            <template v-if="isLoadingCabang">
                                <div class="skeleton skeleton-input" />
                            </template>
                            <template v-else>
                                <div class="balance-status-wrapper d-flex flex-wrap gap-2" v-if="selectedCabang">
                                    <span class="status-box-md status-box-brand">Kelas {{ selectedCabang.branchClass }}</span>
                                    <span class="status-box-md status-box-sand">{{ selectedCabang.isKcu ? 'KCU' : 'KCP' }}</span>
                                    <span class="status-box-md status-box-info">
                                        <i class="fa fa-map-marker mr-1"></i>
                                        {{ selectedCabang.bannerName }}
                                    </span>
                                </div>
                            </template>
                        </div>
                        <div class="balance-action-wrapper d-flex gap-3">
                            <multiselect class="multiselect-balance-cabang"
                                :disabled="isLoadingCabang" 
                                name="filterCabang"
                                v-model="input.filterCabang" 
                                :options="filterCabang" 
                                :internal-search="true"
                                :allow-empty="true"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="name"
                                placeholder="-- Pilih Cabang --"
                            />
                            <b-button
                                class="refresh-balance-btn"
                                variant="pgiBtn"
                                :disabled="isLoadingCabang"
                                @click="reloadBalance()"
                            >
                                <i class="fa fa-refresh mr-1"></i>
                                Hitung Ulang Kas
                            </b-button>
                        </div>
                    </div>
                </template>
                <b-row class="align-items-stretch">
                    <b-col md="4" sm="12" class="balance-card-col d-flex">
                        <div class="ui-b-card w-100 h-100">
                            <div class="ui-b-card-body">
                                <div class="d-flex align-items-center mb-2">
                                    <i class="fa fa-money text-primary mr-2" style="font-size: 30px;"></i> 
                                    <span class="font-weight-bold text-primary" style="font-size: 18px;">Tunai</span>
                                </div>
                                <template v-if="isLoadingCabang">
                                    <div class="skeleton skeleton-input" />
                                </template>
                                <template v-else>
                                    <div class="cash-balance">
                                        <span class="nominal">
                                            Rp. {{ $helper.addThousandSeparator(cashBalance) }}
                                        </span>
                                    </div>
                                    <div>
                                        <span class="smallText text-muted">Kas Laci: </span>
                                        <span class="smallText">Rp. {{ $helper.addThousandSeparator(selectedCabang.kasLaci) }}</span>
                                    </div>
                                    <div>
                                        <span class="smallText text-muted">Kas Brankas: </span>
                                        <span class="smallText">Rp. {{ $helper.addThousandSeparator(selectedCabang.kasBrankas) }}</span>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </b-col>
                    <b-col md="4" sm="12" class="balance-card-col d-flex">
                        <div class="ui-b-card w-100 h-100">
                            <div class="ui-b-card-body">
                                <div class="d-flex align-items-center mb-2">
                                    <i class="fa fa-credit-card-alt text-primary mr-2" style="font-size: 24px;"></i> 
                                    <span class="font-weight-bold text-primary" style="font-size: 18px;">Kas Virtual</span>
                                </div>
                                <div class="cash-balance">
                                    <div v-if="isLoadingCabang" class="skeleton skeleton-input" />
                                    <span v-else class="nominal">
                                        Rp. {{ dokuStatus == STATUS_KAS_VIRTUAL.ACTIVE ? $helper.addThousandSeparator(cashVirtual) : 0 }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col md="4" sm="12" class="balance-card-col d-flex">
                        <div class="ui-b-card w-100 h-100">
                            <div class="ui-b-card-body">
                                <div class="d-flex align-items-center mb-2">
                                    <i class="fa fa-archive text-primary mr-2" style="font-size: 24px;"></i>
                                    <span class="font-weight-bold text-primary" style="font-size: 18px;">Kas Kecil</span>
                                </div>
                                <div class="cash-balance">
                                    <div v-if="isLoadingCabang" class="skeleton skeleton-input" />
                                    <span v-else class="nominal">
                                        Rp. {{ $helper.addThousandSeparator(cashKasKecil) }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-card>

            <b-card >
                <template v-slot:header>
                    <h5>Penilaian Nasabah</h5>
                </template>
                
                <div  class="notification-wrapper">
                    <div class="mb-2">
                        <div class="notif-content">
                            <div class="d-flex flex-wrap">
                                <b-button class="mr-2 mb-2" variant="pgiBtn" @click="getPenilaian()">
                                    Lihat Penilaian
                                </b-button>
                                <b-button class="mb-2" variant="pgiBtn" @click="openSpinWheelModal()">
                                    Buka Spin the Wheel
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </b-card>

            <b-card >
                <template v-slot:header>
                    <div class="dashboard-card-header">
                        <h5>Informasi Umum</h5>
                        <b-button class="dashboard-refresh-btn" variant="pgiBtn" @click="reloadNotif()">
                            <i class="fa fa-refresh mr-1"></i>
                            Refresh
                        </b-button>
                    </div>
                </template>

                <div v-if="isLoading">
                    <div class="text-center">
                        <b-spinner class="loading-spinner" variant="dark" />
                    </div>
                </div>
                
                <div v-else class="notification-wrapper">
                    <div v-if="info.length == 0" class="mb-2">
                        <div class="notif-content">
                            <p class="notif-body">
                                Tidak ada informasi umum baru yang belum anda baca. Untuk melihat seluruh informasi umum, silahkan buka menu Informasi Umum.
                            </p>
                        </div>
                    </div>
                    <ul v-else class="notification-listing-wrapper">
                        <li v-for="(item, index) in info" v-bind:key="index" class="notification-list-wrapper">
                            <div @click="showNotifPage(item.id, item.link)" class="notif-content-wrapper d-flex justify-content-between">
                                <div class="notif-content">
                                    <p class="notif-title">{{ item.jenis.name }}</p>
                                    <p class="notif-body">
                                        {{ item.title }}
                                    </p>
                                </div>
                                <div class="notif-time">
                                    <span>{{ $helper.changeDateFormat(item.tanggalRilis) }} - {{ $helper.changeDateFormatGetHour(item.tanggalRilis) }}</span>
                                </div>
                            </div>
                            <b-button class="delete-notif-btn" variant="pgiBtn" @click="read(item.id)">
                                Baca Informasi
                            </b-button>
                        </li>
                    </ul>
                </div>
            </b-card>
        
            <b-card >
                <template v-slot:header>
                    <div class="dashboard-card-header">
                        <h5>Notifikasi</h5>
                        <b-button class="dashboard-refresh-btn" variant="pgiBtn" @click="reloadNotif()">
                            <i class="fa fa-refresh mr-1"></i>
                            Refresh
                        </b-button>
                    </div>
                </template>
                <div v-if="isLoading">
                    <div class="text-center">
                        <b-spinner class="loading-spinner" variant="dark" />
                    </div>
                </div>
                <div v-else class="notification-wrapper">
                    <div v-if="notifications.length == 0" class="mb-2">
                        <div class="notif-content">
                            <p class="notif-body">
                                Tidak ada notifikasi untuk anda
                            </p>
                        </div>
                    </div>
                    <ul v-else class="notification-listing-wrapper">
                        <li v-for="(item, index) in notifications" v-bind:key="index" class="notification-list-wrapper">
                            <div @click="showNotifPage(item.id, item.link)" class="notif-content-wrapper d-flex justify-content-between">
                                <div class="notif-content">
                                    <p class="notif-title">{{ item.title }}</p>
                                    <p class="notif-body">
                                        {{ item.message }}
                                    </p>
                                </div>
                                <div class="notif-time">
                                    <span>{{ $helper.changeDateFormat(item.createdAt) }} - {{ $helper.changeDateFormatGetHour(item.createdAt) }}</span>
                                </div>
                            </div>
                            <b-button class="delete-notif-btn" variant="danger" @click="openConfirmDeleteNotif(item.id)">
                                <i class="fa fa-trash"></i>
                            </b-button>
                        </li>
                    </ul>
                    <b-pagination class="mb-0"
                        align="right"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                    />
                </div>
            </b-card>

            <b-modal id="modal-detail" title="Detail Informasi Umum" no-close-on-esc no-close-on-backdrop>
                <div v-if="loadInfo">
                    <div class="text-center my-2">
                        Mengambil data, mohon menunggu...
                    </div>
                </div>
                <div v-else>
                    <div v-if="Informasi != null" class="detail-data-wrapper mb-4">
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">Judul Informasi</b-col>
                            <b-col>{{ Informasi.title }}</b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">Jenis Informasi</b-col>
                            <b-col>{{ Informasi.jenis.name }}</b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">Tanggal Rilis</b-col>
                            <b-col>{{$helper.changeDateFormat(Informasi.tanggalRilis)}} {{$helper.changeDateFormatGetHour(Informasi.tanggalRilis)}}</b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">Konten Informasi</b-col>
                            <b-col>{{ Informasi.content }}</b-col>
                        </b-row>
                        <ul v-for="item of Informasi.attachments">
                        <li>
                            <div>
                                {{ item.name }}
                            </div>
                            <a :href="$baseFilePath + item.path" class="btn btn-sm btn-primary no-wrap" target="_blank" download>Buka File</a>
                        </li>
                        </ul>
                    </div>
                </div>
                <template v-slot:modal-footer="{ ok, cancel }">
                    <b-button variant="pgiBtn" name="cancelAjukanAngsuranSajaBtn" @click="cancel()">
                        Tutup
                    </b-button>
                </template>
            </b-modal>

            <b-modal id="modal-penilaian" size="xl" title="Penilaian Nasabah" no-close-on-esc no-close-on-backdrop>
                <h5 class="mb-2">Summary Per 3 Hari Cabang {{ summaryPenilaianCabangName }}</h5>
                <b-table bordered hover show-empty
                    :busy="loadSummaryPenilaian"
                    :items="dataSummaryPenilaian"
                    :fields="fieldsSummaryPenilaian"
                    responsive class="mb-4">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong> Loading data...</strong>
                        </div>
                    </template>
                    <template v-slot:empty>
                        Tidak ada data.
                    </template>
                    <template v-slot:cell(date)="row">
                        <div class="no-wrap">
                           {{$helper.changeDateFormat(row.item.date)}}
                        </div>
                    </template>
                    <template v-slot:cell(persentase)="row">
                        <div class="no-wrap">
                            {{ calcPercent(row.item.qtyReview, row.item.qtyTransaction) }}
                        </div>
                    </template>
                </b-table>

                <h5 class="mb-2">Detail Penilaian</h5>
                <b-button
                    v-if="!showDetailPenilaian"
                    class="mb-3"
                    variant="pgiBtn"
                    @click="showDetailPenilaianSection()"
                >
                    Tampilkan Detail Penilaian
                </b-button>
                <div v-if="showDetailPenilaian">
                    <b-row>
                        <b-col md="4" sm="12" class="mb-2">
                            <label>Cabang</label>
                            <multiselect
                                name="penilaianCabang"
                                v-model="penilaianFilter.cabang"
                                :options="filterCabang"
                                :internal-search="true"
                                :allow-empty="false"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="name"
                                placeholder="-- Pilih Cabang --"
                            />
                        </b-col>
                        <b-col md="4" sm="12" class="mb-2">
                            <label>Tanggal Awal</label>
                            <b-form-input
                                type="date"
                                v-model="penilaianFilter.dateFrom"
                            />
                        </b-col>
                        <b-col md="4" sm="12" class="mb-2">
                            <label>Tanggal Akhir</label>
                            <b-form-input
                                type="date"
                                v-model="penilaianFilter.dateTo"
                            />
                        </b-col>
                    </b-row>
                    <div class="d-flex justify-content-start mt-2 mb-3">
                        <div class="d-flex">
                            <b-button
                                class="mr-2"
                                variant="pgiBtn"
                                :disabled="loadDetailPenilaian"
                                @click="getDetailPenilaian(1)"
                            >
                                Search
                            </b-button>
                            <b-button
                                variant="pgiBtn"
                                :disabled="loadDetailPenilaian || isDownloadingPenilaian"
                                @click="openConfirmDownloadPenilaian()"
                            >
                                <i class="fa fa-download mr-2"></i>
                                Download Excel
                            </b-button>
                        </div>
                    </div>
                    <b-table bordered hover show-empty
                        :busy="loadDetailPenilaian"
                        :items="dataDetailPenilaian"
                        :fields="fieldsDetailPenilaian"
                        responsive class="mb-3">
                        <template v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong> Loading data...</strong>
                            </div>
                        </template>
                        <template v-slot:empty>
                            Tidak ada data.
                        </template>
                        <template v-slot:cell(dataKunjungan)="row">
                            <div>
                                <span class="text-muted">Cabang:</span> {{ row.item.cabang || '-' }}
                            </div>
                            <div>
                                <span class="text-muted">Tanggal:</span> {{ formatPenilaianDate(row.item.createdAt) }}
                            </div>
                        </template>
                        <template v-slot:cell(penilaianLayanan)="row">
                            <div>
                                <span class="text-muted">Nilai Pelayanan:</span> {{ row.item.nilaiPelayanan || '-' }}
                            </div>
                            <div>
                                <span class="text-muted">Nilai Kebersihan:</span> {{ row.item.nilaiKebersihan || '-' }}
                            </div>
                        </template>
                        <template v-slot:cell(penilaianTransaksi)="row">
                            <div>
                                <span class="text-muted">Jenis Transaksi:</span> {{ row.item.jenisTransaksi || '-' }}
                            </div>
                            <div>
                                <span class="text-muted">Kecepatan Transaksi:</span> {{ row.item.kecepatanTransaksi || '-' }}
                            </div>
                        </template>
                        <template v-slot:cell(kritikSaranDetail)="row">
                            <div>
                                <span class="text-muted">Kritik & Saran:</span> {{ row.item.kritikSaran || '-' }}
                            </div>
                        </template>
                    </b-table>

                    <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                        <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                            <b-form-select v-model="showPenilaian" @change="onLimitPenilaianChange" :options="optionsLimitPenilaian">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled />
                                </template>
                            </b-form-select>
                            <span class="ml-2">{{ totalViewTextPenilaian }}</span>
                        </b-input-group>
                        <b-pagination
                            class="mb-0"
                            v-model="currentPagePenilaian"
                            :total-rows="totalRowsPenilaian"
                            :per-page="perPagePenilaian"
                            @input="onPagePenilaianChange"
                        />
                    </div>
                </div>
                <template v-slot:modal-footer="{ ok, cancel }">
                    <b-button variant="pgiBtn" name="cancelAjukanAngsuranSajaBtn" @click="cancel()">
                        Tutup
                    </b-button>
                </template>
            </b-modal>

            <b-modal id="modal-download-penilaian" title="Download Penilaian Nasabah" centered hide-footer no-close-on-esc no-close-on-backdrop>
                <div>
                    File sudah siap. Tekan tombol dibawah ini untuk download detail penilaian Excel.
                    <div class="mt-2">
                        <a :href="$baseFilePath + '/' + linkDownloadPenilaian" download>
                            <b-button variant="primary">
                                <i class="fa fa-download mr-2" />Download Excel
                            </b-button>
                        </a>
                    </div>
                </div>
            </b-modal>

            <b-modal
                id="modal-spin-wheel"
                title="Buka Spin the Wheel"
                centered
                no-close-on-esc
                no-close-on-backdrop
            >
                <b-form-group label="Nomor Faktur" label-for="spin-wheel-no-faktur" class="mb-2">
                    <b-form-input
                        id="spin-wheel-no-faktur"
                        v-model.trim="noFakturSpinWheel"
                        placeholder="Masukkan nomor faktur"
                        :disabled="isProcessingSpinWheel"
                        @keyup.enter="processSpinWheel()"
                    />
                </b-form-group>
                <b-alert v-if="spinWheelError" show variant="danger" class="mb-0">
                    {{ spinWheelError }}
                </b-alert>
                <b-button
                    variant="pgiBtn"
                    class="mt-2"
                    :disabled="isProcessingSpinWheel"
                    @click="processSpinWheel()"
                >
                    <b-spinner v-if="isProcessingSpinWheel" small class="mr-1" />
                    Proses
                </b-button>
                <hr v-if="spinWheelLink" class="mt-3 mb-3">
                <a
                    v-if="spinWheelLink"
                    :href="spinWheelLink"
                    class="btn btn-pgiBtn"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <i class="fa fa-external-link mr-1"></i>
                    Buka Halaman Spin
                </a>
                <template v-slot:modal-footer="{ cancel }">
                    <b-button
                        variant="secondary"
                        :disabled="isProcessingSpinWheel"
                        @click="cancel()"
                    >
                        Batal
                    </b-button>
                </template>
            </b-modal>

        </div>
        <ModalConfirm id="modal-confirm-delete" title="Confirm Delete Notifikasi" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menghapus notifikasi ini?" @submit="onDelete()" />
        <ModalConfirm id="modal-confirm-download-penilaian" title="Konfirmasi Download" :isSubmitting="isDownloadingPenilaian" desc="Apakah anda yakin ingin download detail penilaian nasabah?" @submit="onDownloadPenilaian()" />
    </div>
</template>

<script>
import CONSTANTS from '@/constants'

export default {
    name: 'dashboard',
    data() {
        return {
            dokuStatus: 0,
            isLoadingCabang: false,
            id: null,
            isSubmitting: false,
            initStatus: 0,
            isLoading: false,
            token: localStorage.getItem("token"),
            currentPage: 1,
            perPage: 10,
            rows: 0,
            notifications: [],
            input: {
                filterCabang: null,
            },
            filterCabang:[],
            cashBalance: null,
            cashVirtual: null,
            cashKasKecil: 0,
            info: [],

            count : this.$unreadCount,
            loadInfo: false,
            Informasi: null,

            dataSummaryPenilaian: [],
            dataDetailPenilaian: [],
            loadSummaryPenilaian: false,
            loadDetailPenilaian: false,
            showDetailPenilaian: false,
            isDownloadingPenilaian: false,
            linkDownloadPenilaian: null,
            currentPagePenilaian: 1,
            showPenilaian: 10,
            perPagePenilaian: 10,
            totalRowsPenilaian: 0,
            totalViewTextPenilaian: "",
            optionsLimitPenilaian: [10, 20, 30, 40, 50],
            noFakturSpinWheel: "",
            spinWheelError: "",
            spinWheelLink: "",
            isProcessingSpinWheel: false,
            penilaianFilter: {
                cabang: null,
                dateFrom: null,
                dateTo: null,
            },

            fieldsSummaryPenilaian: [
                { key: "date", label: "Tanggal"},
                { key: "qtyReview", label: "Qty Review", sortable:true},
                { key: "qtyTransaction", label: "Qty Transaksi"},
                { key: "persentase", label: "Persentase"},
                { key: "avgRating", label: "Rata-rata Penilaian"},
            ],
            fieldsDetailPenilaian: [
                { key: "dataKunjungan", label: "Data Kunjungan"},
                { key: "penilaianLayanan", label: "Penilaian Layanan"},
                { key: "penilaianTransaksi", label: "Penilaian Transaksi"},
                { key: "kritikSaranDetail", label: "Kritik & Saran"},
            ],
            selectedCabang: null,
        }
    },
    watch: {
        currentPage(newVal) {

            this.notifications = []
            this.isLoading = true

            this.$axios.get("notification/?page=" + (newVal - 1)).then(response => {
                this.notifications = response.data.data
                this.rows = response.data.total
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isLoading = false
            })

        },
        'input.filterCabang': function(newVal) {
            this.getCabangById(newVal.id)
        },
    },
    computed: {
        STATUS_KAS_VIRTUAL() {
            return CONSTANTS.CABANG.STATUS_KAS_VIRTUAL
        },
        summaryPenilaianCabangName() {
            let cabangId = this.$helper.getCabangId()
            let cabang = this.filterCabang.find(item => `${item.id}` == `${cabangId}`)

            return cabang ? cabang.name : "-"
        },
    },
    methods: {
        getCabangById(id, withLoading = true, handleError = true) {
            let idCabang;
            if (id) {
                idCabang = id
            } else {
                idCabang = this.$helper.getCabangId()
            }

            if (withLoading) {
                this.isLoadingCabang = true
            }

            return this.$axios.get(`cabang/${idCabang}`).then(response => {
                this.dokuStatus = response.data.dokuStatus
                this.selectedCabang = response.data
                this.cashBalance = response.data.cashInHand
                this.cashVirtual = response.data.cashVirtual
                this.cashKasKecil = response.data.kasKecil || 0
                return this.refreshBalanceKasKecil(idCabang)
            }).catch(error => {
                if (handleError) {
                    this.$helper.parseError(this, error)
                    return
                }

                return Promise.reject(error)
            }).finally(() => {
                if (withLoading) {
                    this.isLoadingCabang = false
                }
            })
        },
        calcPercent: function (qty, trans) {
            let result = (qty * 100) / trans;
            if (result == "Infinity" ) {
                return "-";
            }
            return result.toFixed(2) + " %";
        },

        getUnreadCount() {
        // Make a request using the axios instance with the interceptor
        this.$axios.get('informasi-umum/count-unreads')
            .then(response => {
                this.$store.state.readCount = response.data.id
        
            })
            .catch(error => {
            console.error(error)
            })
        },

        getPenilaian(){
            let today = this.getTodayDateValue()

            this.penilaianFilter.cabang = this.input.filterCabang
            this.penilaianFilter.dateFrom = this.penilaianFilter.dateFrom || today
            this.penilaianFilter.dateTo = this.penilaianFilter.dateTo || today
            this.dataDetailPenilaian = []
            this.showDetailPenilaian = false
            this.currentPagePenilaian = 1
            this.totalRowsPenilaian = 0
            this.updateTotalViewTextPenilaian()

            this.$bvModal.show('modal-penilaian')
            this.getSummaryPenilaian()
        },

        openSpinWheelModal() {
            this.noFakturSpinWheel = ""
            this.spinWheelError = ""
            this.spinWheelLink = ""
            this.$bvModal.show("modal-spin-wheel")
        },

        processSpinWheel() {
            const noFaktur = `${this.noFakturSpinWheel || ""}`.trim()

            this.spinWheelError = ""
            this.spinWheelLink = ""

            if (!noFaktur) {
                this.spinWheelError = "Nomor faktur wajib diisi."
                return
            }

            this.isProcessingSpinWheel = true
            return this.$axios.get("/api/nasabah-penilaian/play-spin-the-wheel", {
                params: { noFaktur },
            })
                .then(response => {
                    const result = response.data || {}

                    if (Number(result.id) !== 1 || !result.name) {
                        this.spinWheelError = "NF ini sudah tidak bisa dibuka spin the wheel nya!"
                        return
                    }

                    this.spinWheelLink = result.name
                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isProcessingSpinWheel = false
                })
        },

        getSummaryPenilaian() {
            let cabangId = this.$helper.getCabangId()

            if (!cabangId) {
                this.$helper.toastErr(this, "Cabang wajib diisi")
                return
            }

            this.loadSummaryPenilaian = true
            this.$axios.get('/api/nasabah-penilaian/recent', {
                params: { cabangId }
            })
            .then(response => {
                this.dataSummaryPenilaian = response.data || []
            })
            .catch(error => {
                console.error(error)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.loadSummaryPenilaian = false
            })
        },

        showDetailPenilaianSection() {
            this.showDetailPenilaian = true
            this.getDetailPenilaian(1)
        },

        openConfirmDownloadPenilaian() {
            if (!this.validatePenilaianFilter()) {
                return
            }

            this.$bvModal.show("modal-confirm-download-penilaian")
        },

        onDownloadPenilaian() {
            let cabang = this.getPenilaianCabangCode(this.penilaianFilter.cabang)

            this.isDownloadingPenilaian = true
            this.$axios.post('/pub-facing/export-excel-nasabah-penilaian', null, {
                params: {
                    cabang,
                    dateFrom: this.penilaianFilter.dateFrom,
                    dateTo: this.penilaianFilter.dateTo,
                }
            })
                .then(response => {
                    this.linkDownloadPenilaian = response.data.name.replace(/^\/+/, "")
                    this.$bvModal.hide("modal-confirm-download-penilaian")
                    this.$bvModal.show("modal-download-penilaian")
                })
                .catch(error => {
                    console.error(error)
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isDownloadingPenilaian = false
                })
        },

        getDetailPenilaian(page = 1) {
            let cabang = this.getPenilaianCabangCode(this.penilaianFilter.cabang)

            if (!this.validatePenilaianFilter()) {
                return
            }

            this.currentPagePenilaian = page
            this.loadDetailPenilaian = true
            this.$axios.get('/pub-facing/get-detail-nasabah-penilaian', {
                params: {
                    cabang,
                    dateFrom: this.penilaianFilter.dateFrom,
                    dateTo: this.penilaianFilter.dateTo,
                    page: this.currentPagePenilaian - 1,
                    size: this.perPagePenilaian,
                }
            })
                .then(response => {
                    this.dataDetailPenilaian = response.data.content || []
                    this.totalRowsPenilaian = response.data.totalElements || this.dataDetailPenilaian.length
                    this.updateTotalViewTextPenilaian()
                })
                .catch(error => {
                    console.error(error)
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.loadDetailPenilaian = false
                })
        },

        updateTotalViewTextPenilaian() {
            if (this.totalRowsPenilaian === 0) {
                this.totalViewTextPenilaian = "0 dari 0 data"
                return
            }

            const prev = (this.currentPagePenilaian - 1) * this.perPagePenilaian + 1
            let limit = (this.currentPagePenilaian - 1) * this.perPagePenilaian + this.perPagePenilaian
            if (limit > this.totalRowsPenilaian) limit = this.totalRowsPenilaian
            this.totalViewTextPenilaian = `Menampilkan ${prev} - ${limit} dari ${this.totalRowsPenilaian} entri`
        },

        onLimitPenilaianChange(newPerPage) {
            this.perPagePenilaian = newPerPage
            this.getDetailPenilaian(1)
        },

        onPagePenilaianChange(newPage) {
            this.getDetailPenilaian(newPage)
        },

        isValidPenilaianFilter() {
            let cabang = this.getPenilaianCabangCode(this.penilaianFilter.cabang)

            return cabang && this.penilaianFilter.dateFrom && this.penilaianFilter.dateTo
        },

        isValidPenilaianDateRange() {
            return this.penilaianFilter.dateFrom <= this.penilaianFilter.dateTo
        },

        getTodayDateValue() {
            let date = new Date()
            let month = `${date.getMonth() + 1}`.padStart(2, "0")
            let day = `${date.getDate()}`.padStart(2, "0")
            return `${date.getFullYear()}-${month}-${day}`
        },

        getPenilaianCabangCode(cabang) {
            if (!cabang) {
                return ""
            }

            const code = cabang.name.replace(/^\(\d+\)\s*/, '').toLowerCase()

            return code || ""
        },

        formatPenilaianDate(date) {
            if (!date) {
                return "-"
            }

            return `${this.$helper.changeDateFormat(date)} ${this.$helper.changeDateFormatGetHour(date)}`
        },

        init() {
            if(localStorage.getItem("reload") !== null && localStorage.getItem("reload") === "1") {
                localStorage.removeItem("reload")
                window.location.reload(true)
            }

            this.initStatus = 0

            let getNotif = this.$axios.get("notification/?page=0").then(response => {
                this.notifications = response.data.data
                this.rows = response.data.total
            })

            let getInfo = this.$axios.get("informasi-umum/unreads").then(response => {
                this.info = response.data
            })

            let activeCabangId = this.$helper.getCabangId()
            this.filterCabang = this.$helper.getAllCabang()
            let idx = this.filterCabang.findIndex(item => item.id == activeCabangId);
            this.input.filterCabang = this.filterCabang[idx]

            let getCabang = this.$axios.get(`cabang/${activeCabangId}`).then(response => {
                this.selectedCabang = response.data
                this.dokuStatus = response.data.dokuStatus
                this.cashBalance = response.data.cashInHand
                this.cashVirtual = response.data.cashVirtual
                this.cashKasKecil = response.data.kasKecil || 0
                return this.refreshBalanceKasKecil(activeCabangId)
            })

            Promise.all([getNotif, getCabang,getInfo]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        reloadNotif(){
            this.isLoading = true
            this.$axios.get("notification/?page=0").then(response => {
                this.notifications = response.data.data
                this.rows = response.data.total
            }).finally(() => {
                this.isLoading = false
            })
        },
      
        reloadInfo(){
            this.isLoading = true
            this.$axios.get("informasi-umum/unreads").then(response => {
                this.info = response.data
            }).finally(() => {
                this.isLoading = false
            })
        },

        read(id){
            this.loadInfo = true
            this.$bvModal.show('modal-detail')

            this.$axios.get("informasi-umum/" + id ).then(response => {
             this.Informasi = response.data
                this.$axios.post("informasi-umum/mark-read?informasiUmumId=" + id ).then(response => {
                    this.reloadInfo()
                    this.getUnreadCount()
                }).finally(() => {
                    this.isLoading = false
                })

            }).catch((error)=>{
                this.loadInfo = false
                this.$helper.toastErr(this, error.response.data.reason)
                this.$bvModal.hide('modal-detail')
                this.info = this.info.filter(item => item.id != id)
                this.$store.state.readNotifstore.readCount = this.$store.state.readNotifstore.readCount -1

            }).finally(() => {
                this.loadInfo = false
            })


        
        },
        reloadBalance() {
            const id = this.selectedCabang.id
            let payload = new FormData()
            payload.append("id", id)

            this.isLoadingCabang = true
            let refreshBalance = this.$axios.post("cabang/refresh-balance/", payload).then(response => {
                this.cashBalance = response.data.cashInHandBerjalan
                this.cashVirtual = response.data.cashVirtual
            })
            let refreshBalanceLaciBrankas = this.$axios.post(`cabang/refresh-balance-laci-brankas?cabangId=${id}`)
            let refreshBalanceKasKecil = this.refreshBalanceKasKecil(id)

            return Promise.all([refreshBalance, refreshBalanceLaciBrankas, refreshBalanceKasKecil]).then(() => {
                return this.getCabangById(id, false, false)
            }).catch(error => {
                this.$helper.parseError(this, error)
            }).finally(() => {
                this.isLoadingCabang = false
            })
        },
        refreshBalanceKasKecil(cabangId) {
            if (!cabangId) return Promise.resolve()

            return this.$axios.post(`cabang/refresh-balance-kas-kecil?cabangId=${cabangId}`)
                .then(response => {
                    this.cashKasKecil = response.data && response.data.kasKecil
                        ? response.data.kasKecil
                        : 0
                })
        },

        //----------------- Fungsi Delete Notif -----------------

        onDelete(){
            let payload = new FormData()
            //----------------- Append Data -----------------

            payload.append("id", this.id)

            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true

            this.$axios.post("notification/delete/", payload).then(response => {
                this.$helper.toastSucc(this, "Notifikasi berhasil dihapus!")
                this.$bvModal.hide("modal-confirm-delete")
                let idx = this.notifications.findIndex(item => item.id == this.id);
                this.notifications.splice(idx, 1)
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        openConfirmDeleteNotif(id){

            this.id = id
            this.$bvModal.show("modal-confirm-delete")
        },

        showNotifPage(id, url){
            let payload = new FormData()
            //----------------- Append Data -----------------

            payload.append("id", id)

            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true

            this.$axios.post("notification/delete/", payload).then(response => {
                // this.$router.push({ path: url })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                // this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
                this.$router.push({ path: url })
            })
        },

        validatePenilaianFilter() {
            if (!this.isValidPenilaianFilter()) {
                this.$helper.toastErr(this, "Cabang dan range tanggal wajib diisi")
                return false
            }

            if (!this.isValidPenilaianDateRange()) {
                this.$helper.toastErr(this, "Tanggal awal tidak boleh lebih baru dari tanggal akhir")
                return false
            }

            return true
        },
    },
    created() {
        this.init()
    }
}
</script>

<style>
@media (max-width: 768px) {
    .balance-card-col {
        margin-bottom: 15px;
    }
}

.custom-card-dashboard.balance-card {
    min-height: auto; 
}

.refresh-balance-btn {
    white-space: nowrap;
}

.dashboard-card-header {
    align-items: center;
    border-bottom: 1px solid #c8ced3;
    display: flex;
    justify-content: space-between;
    gap: 12px;
    padding-bottom: 1rem;
}

.dashboard-card-header h5 {
    align-items: center;
    border-bottom: none !important;
    display: flex;
    margin-bottom: 0 !important;
    min-height: 38px;
    padding-bottom: 0 !important;
}

.dashboard-refresh-btn {
    align-items: center;
    display: inline-flex;
    justify-content: center;
    white-space: nowrap;
}

@media (max-width: 576px) {
    .balance-action-wrapper {
        width: 100%;
        flex-direction: column;
    }

    .balance-status-wrapper {
        margin-bottom: 4px;
        width: 100%;
    }

    .balance-status-wrapper .status-box-md {
        margin-bottom: 4px;
    }

    .balance-action-wrapper .multiselect-balance-cabang {
        max-width: none;
        width: 100%;
    }

    .refresh-balance-btn {
        width: 100%;
    }

    .dashboard-refresh-btn {
        width: 100%;
    }

    .dashboard-card-header {
        align-items: stretch;
        flex-direction: column;
    }
}

</style>
